import { useEffect, useRef } from 'react';

import type { Message } from '@/features/ai-chat/types/chat.types';

export function useChatScroll(messages: Message[]) {
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = bottomRef.current as unknown as {
      scrollIntoView?: (opts?: ScrollIntoViewOptions) => void;
    } | null;
    el?.scrollIntoView?.({ behavior: 'smooth' });
  }, [messages]);

  return bottomRef;
}
